export default __webpack_public_path__ + "static/stack-usage-example-6637e5fba92348dc724e7eba5b7e5880f5ba7b5449b849757446b98571b0369c.png";